module.exports = __webpack_public_path__ + "static/media/general-de-seguros-plus.b566a7b0.svg";